import * as React from 'react'

import { useSideMenuCollapsed } from '@enechain/ecloud-designsystem'
import { EClearV2, EClearV2Symbol } from '@enechain/ecloud-icons'

export const ProductLogo: React.FC = () => {
  const { collapsed } = useSideMenuCollapsed()

  if (collapsed) {
    return (
      <EClearV2Symbol
        width="24px"
        height="24px"
        marginLeft="-4px"
        aria-hidden
      />
    )
  }
  return <EClearV2 width="118px" height="24px" marginLeft="-4px" aria-hidden />
}
